import { useQuery } from '@tanstack/react-query'
import apiClient from '@/api/client'
import type { MapsConfig } from '@/lib/maps/types'

const OFF: MapsConfig = { browser_key: '', source: '', search: false, usage_today: {}, daily_cap: 0 }

/**
 * Which Google key draws the map, and whether address search is available.
 * Keys are issued by Bhookly (F-BE-N90) — there is nothing for a tenant to
 * set up. A failed fetch reads as "maps off", never as an error page.
 */
export function useMapsConfig(enabled = true) {
  return useQuery({
    queryKey: ['maps', 'config'],
    queryFn: async (): Promise<MapsConfig> => {
      try {
        const res = await apiClient.getMapsConfig()
        return res.success && res.data ? res.data : OFF
      } catch {
        return OFF
      }
    },
    staleTime: 10 * 60_000,
    enabled,
  })
}
